import React, { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useParams } from "react-router-dom";
import {
  checkAcessRights,
  convertToWords,
  formatIndianNumber,
  getAccountingYear,
} from "../../_helper/helper";
import moment from "moment";
import { PRINT_ACCESS } from "../../_contstants/common";
import { Button } from "@progress/kendo-react-buttons";
import { getDebitnoteVoucherByID } from "./services/debitnoteVoucher";
import { clearDebitnoteVoucherDetails } from "./debitnoteVoucherSlice";
import { LoadingPanel } from "../../components/layout/Loading";

const DebitNoteVoucherPrint: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const params = useParams();
  const debit_note_voucher_guid = params?.debit_note_voucher_guid;
  const loading = useAppSelector((state) => state.debitnotevoucher.loading);
  const DebitnoteVoucherDetail = useAppSelector(
    (state) => state.debitnotevoucher.DebitnoteVoucherDetail
  );
  const isPrintAccess = checkAcessRights("/debitnotevoucher", PRINT_ACCESS);

  useEffect(() => {
    if (debit_note_voucher_guid) {
      const handleDriverVisitPrint = async () => {
        const res = await dispatch(
          getDebitnoteVoucherByID(debit_note_voucher_guid)
        );
        if (res.meta.requestStatus === "fulfilled") {
          window.print();
        }
      };
      handleDriverVisitPrint();
    }
  }, [debit_note_voucher_guid]);

  useEffect(() => {
    return () => {
      dispatch(clearDebitnoteVoucherDetails());
    };
  }, []);

  if (loading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      <div className="container p-4 drivervisit-print-page">
        <div className="position-relative no-visible-print-btn text-end p-2">
          {isPrintAccess && (
            <Button
              style={{ marginRight: 5 }}
              type="button"
              fillMode={"solid"}
              themeColor={"primary"}
              onClick={() => window.print()}
            >
              Print
            </Button>
          )}
        </div>
        <p className="text-center">
          <b>Harihar Foods Pvt. Ltd. {getAccountingYear()}</b>
          <br />
          519/1, Nr Ramol Police Chowky
          <br />
          Phase IV, G.I.D.C. Vatva, Ahmedabad 382445
          <br />
          Tel (Off) 079-25841773/25840855 <br />
          FSSAI No: 10012021000359 <br />
          State Name: Gujarat, Code: 24 <br />
          CIN: U15499GJ1994PTC021520 <br />
          E-Mail: marketing@shreeganeshmasala.com
        </p>
        <br />
        <p className="text-center">
          <b>DEBIT NOTE</b>
        </p>
        <div className="d-flex justify-content-between">
          <p className="m-0">
            No.:{" "}
            <span className="fw-bold">
              {DebitnoteVoucherDetail?.debit_note_voucher_no_string}
            </span>
          </p>
          <p className="m-0">
            Dated :{" "}
            <span className="fw-bold">
              {DebitnoteVoucherDetail?.debit_note_voucher_date
                ? moment(
                    DebitnoteVoucherDetail?.debit_note_voucher_date,
                    "DD MMM YYYY HH:mm"
                  ).format("DD-MMM-YYYY")
                : ""}
            </span>
          </p>
        </div>
        <div className="w-75 mb-2">
          <table className="w-100">
            <tr>
              <td style={{ verticalAlign: "baseline", whiteSpace: "nowrap" }}>
                Party's Name
              </td>
              <td style={{ verticalAlign: "baseline" }}>:</td>
              <td style={{ verticalAlign: "baseline" }}>
                <p className="fw-600 mb-1">
                  {DebitnoteVoucherDetail?.debit_note_voucher_entry &&
                    DebitnoteVoucherDetail?.debit_note_voucher_entry?.length >
                      0 &&
                    DebitnoteVoucherDetail?.debit_note_voucher_entry[0]
                      ?.ledger_name}
                </p>
                {DebitnoteVoucherDetail?.debit_note_voucher_entry &&
                  DebitnoteVoucherDetail?.debit_note_voucher_entry?.length >
                    0 && (
                    <>
                      <p className=" m-0">
                        {
                          DebitnoteVoucherDetail?.debit_note_voucher_entry[0]
                            ?.address
                        }
                      </p>
                      <p className=" m-0">
                        Mo.No.:
                        {
                          DebitnoteVoucherDetail?.debit_note_voucher_entry[0]
                            ?.mobile_number
                        }
                      </p>
                    </>
                  )}
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: "baseline" }}>GSTIN/UIN</td>
              <td style={{ verticalAlign: "baseline" }}>:</td>
              <td style={{ verticalAlign: "baseline", fontWeight: 600 }}>
                {DebitnoteVoucherDetail?.debit_note_voucher_entry &&
                  DebitnoteVoucherDetail?.debit_note_voucher_entry?.length >
                    0 &&
                  DebitnoteVoucherDetail?.debit_note_voucher_entry[0]?.gst_no}
              </td>
            </tr>
          </table>
        </div>
        <table className="drivervisit-print-table">
          <tr
            style={{
              borderTop: "1px solid black",
              borderBottom: "1px solid black",
            }}
          >
            <td style={{ width: "75%" }}>Particulars</td>
            <td
              style={{
                textAlign: "end",
                width: "25%",
                borderLeft: "1px solid black",
              }}
            >
              Amount
            </td>
          </tr>
          {/* <tr>
            <td className="fw-bold">Account :</td>
            <td style={{ borderLeft: "1px solid black" }}></td>
          </tr> */}
          {DebitnoteVoucherDetail?.debit_note_voucher_entry &&
            DebitnoteVoucherDetail?.debit_note_voucher_entry?.length > 0 &&
            DebitnoteVoucherDetail?.debit_note_voucher_entry
              ?.slice(1)
              ?.map((payment: any) => {
                return (
                  <tr>
                    <td className="ps-3 fw-600">{payment.ledger_name}</td>
                    <td
                      className="fw-bold text-end"
                      style={{ borderLeft: "1px solid black" }}
                    >
                      {formatIndianNumber(payment.amount)}
                    </td>
                  </tr>
                );
              })}
          {/* <tr>
            <td className="fw-bold pt-3">Through :</td>
            <td style={{ borderLeft: "1px solid black" }}></td>
          </tr>
          <tr>
            <td className="ps-3">{DebitnoteVoucherDetail?.account_name}</td>
            <td style={{ borderLeft: "1px solid black" }}></td>
          </tr> */}
          <tr>
            <td className="fw-bold pt-3">On Account of :</td>
            <td style={{ borderLeft: "1px solid black" }}></td>
          </tr>
          {DebitnoteVoucherDetail?.remarks ? (
            <tr>
              <td className="ps-3">{DebitnoteVoucherDetail?.remarks}</td>
              <td style={{ borderLeft: "1px solid black" }}></td>
            </tr>
          ) : null}
          <tr>
            <td className="fw-bold pt-3">Amount (in words) :</td>
            <td style={{ borderLeft: "1px solid black" }}></td>
          </tr>
          <tr>
            <td className="ps-3">
              {convertToWords(
                DebitnoteVoucherDetail?.debit_note_voucher_total_amount || 0
              )}
            </td>
            <td style={{ borderLeft: "1px solid black" }}></td>
          </tr>
          <tr>
            <td style={{ borderBottom: "1px solid black" }}></td>
            <td
              className="fw-bold text-end"
              style={{ border: "1px solid black", borderRight: "none" }}
            >
              Rs.{" "}
              {formatIndianNumber(
                DebitnoteVoucherDetail?.debit_note_voucher_total_amount || 0
              )}
            </td>
          </tr>
        </table>
        <div className="row mt-2">
          <div className="col-12">
            <p className="text-end fw-600 mb-5">
              for Harihar Foods Pvt.Ltd. {getAccountingYear()}
            </p>
          </div>
          <div className="col-12">
            <p className="text-end">Authorised Signatory</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default DebitNoteVoucherPrint;
